import axios from 'axios';

const TOKEN_KEY = 'immo_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({
  baseURL: (process.env.REACT_APP_API_URL || '') + '/api',
});

// Injecte le JWT sur chaque requête
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Déconnecte sur 401 (token expiré/invalide)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && getToken()) {
      clearToken();
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export default api;
